﻿import controller from './controller';
import { translate } from './localization'

function accessibleFileUpload(context) {
  const fileInput = context.querySelector('input[type="file"]');
  let buttonText = '';

    if (!fileInput) {
        console.warn("No file input found in context", context);
        return () => {};
    }

	function showFileUploadName(e, button) {
    if(e.target.value) {
      button.innerHTML = e.target.value.split('\\').pop();
      button.classList.add('FormFileUpload__button--noicon');
    } else {
      button.innerHTML = buttonText;
      button.classList.remove('FormFileUpload__button--noicon');
    }
	}
  
  async function init() {
    buttonText = await translate('/episerver/forms/viewmode/fileupload');

		const button = document.createElement('button');
    button.classList.add('FormFileUpload__button');

    button.addEventListener("click", (e) => {
      fileInput.click();
      e.preventDefault();
    });

    button.innerHTML = buttonText;

    fileInput.parentNode.insertBefore(button, fileInput);
    fileInput.addEventListener('change', (event) => showFileUploadName(event, button));
  }

  return {
    init
  };
}

controller.add('accessible-fileupload', accessibleFileUpload);
